import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MainHeader } from "../components";

const LoginLayout = ({ children }) => (
  <Container fluid className="h-100 ">
    <Row className="h-100 pink-pie-bg">
      <Row>
        <MainHeader />
      </Row>
      <Col
        className="main-content p-0 h-100"
        lg={{ size: 12 }}
        md={{ size: 12 }}
        sm="12"
        tag="main"
      >
        {children}
      </Col>
    </Row>
  </Container>
);

export default LoginLayout;